enum TradeManagerView {

    Symbol,
    Alert
}
export default TradeManagerView;
